import { automaticApi, getUserProductApi } from "../../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setCustomer } from "@/redux/ducks/customer";
import { Vehicle } from "@/pages/auth/vehicles/Models";
import { mergeVehicleLists } from "@/redux/sagas/vehicles/utils";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export interface Fetch {
  callback: (success: boolean) => void;
}

export interface GetDataAction {
  type: string;
  payload: Fetch;
}

export default function* getData({
  payload,
}: GetDataAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const response = yield call(
      automaticApi.get,
      `/login-app/${environment.api?.loginVersion ?? "v4"}/userdata`,
    );
    const respondeData = response?.data;

    if (respondeData?.status?.sessionId) {
      window?.dataLayer?.push({
        userId: response?.data?.client?.id,
      });
      yield put(
        setCustomer({
          client: response?.data?.client,
          account: response?.data?.account,
          isLoadingVehicles: false,
        }),
      );

      const { path, pageSize } = environment.api.userProduct;
      const userProductApi = getUserProductApi();

      let fromPage = 1;
      let totalPages = 1;
      let allListVehicle: Vehicle[] = [];
      let allListGarageVehicle: Vehicle[] = [];
      let products: unknown;

      do {
        const responseProducts = yield call(
          userProductApi.get,
          `${path}?offset=${pageSize}&fromPage=${fromPage}`,
        );

        if (responseProducts?.data?.contractedProductPagination?.totalPages) {
          totalPages =
            responseProducts.data.contractedProductPagination.totalPages;
        }

        if (Array.isArray(responseProducts?.data?.listVehicle)) {
          allListVehicle = [
            ...allListVehicle,
            ...responseProducts.data.listVehicle,
          ];
        }
        if (Array.isArray(responseProducts?.data?.listGarageVehicle)) {
          allListGarageVehicle = [
            ...allListGarageVehicle,
            ...responseProducts.data.listGarageVehicle,
          ];
        }
        if (responseProducts?.data?.products) {
          products = responseProducts.data.products;
        }

        fromPage++;
      } while (fromPage <= totalPages);

      const vehicles = mergeVehicleLists(allListVehicle, allListGarageVehicle);

      const selectedVehicles = vehicles?.map((vehicle) => vehicle.plate);
      const shouldInitializeSelectedVehicles =
        (selectedVehicles?.length ?? 0) > 0;

      yield put(
        setCustomer({
          products,
          vehicles,
          ...(shouldInitializeSelectedVehicles &&
            selectedVehicles && { selectedVehicles }),
        }),
      );
      yield call(payload.callback, true);
    } else {
      yield put(
        setCustomer({
          isLoadingVehicles: false,
        }),
      );
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield put(
      setCustomer({
        isLoadingVehicles: false,
      }),
    );
    yield call(payload.callback, false);
  }
}
